// https://github.com/zloirock/core-js#index

import 'core-js/modules/es.array.iterator.js'
import 'core-js/modules/es.array.at'
import 'core-js/modules/es.array.fill'
import 'core-js/modules/es.array.flat'
import 'core-js/modules/es.array.flat-map'
import 'core-js/modules/es.array.from'
import 'core-js/modules/es.array.to-sorted.js'
import 'core-js/modules/es.array.to-reversed.js'
import 'core-js/modules/es.array.to-spliced.js'
import 'core-js/modules/esnext.array.group.js'
import 'core-js/modules/esnext.array.group-to-map.js'

import 'core-js/modules/es.object.assign'
import 'core-js/modules/es.object.define-properties'
import 'core-js/modules/es.object.define-property'
import 'core-js/modules/es.object.get-own-property-descriptors'

import 'core-js/modules/es.string.pad-start'
import 'core-js/modules/es.string.pad-end.js'
import 'core-js/modules/es.string.starts-with'

import 'core-js/modules/es.promise.finally'
import 'core-js/modules/es.promise.race'
import 'core-js/modules/es.promise.all-settled'

import 'core-js/modules/es.error.cause.js'
